<div class="atividade-filter-visibilidade">
    <div class="dropdown dropdown-visibilidade">
        <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="{{visibilidade | atividadeFilterVisibilidadeIcon}}"></i> {{visibilidade | atividadeFilterVisibilidade}}
        </button>
        <div class="dropdown-menu">
            <ng-template ngFor let-visibilidadeDisponivel [ngForOf]="visibilidadesDisponiveis">
                <a class="dropdown-item" 
                    [ngClass]="{'active': visibilidadeDisponivel.id === visibilidade}"
                    (click)="selectVisibilidade(visibilidadeDisponivel)">
                    <i class="{{visibilidadeDisponivel.iconClass}}"></i> {{visibilidadeDisponivel.nome}}
                </a>
            </ng-template>
        </div>
    </div>

    <div class="multiselect-usuarios-destino" *ngIf="isShowUsuariosDestino()">
        <ss-multiselect-dropdown
            [options]="multiselectUsuariosDestinoOptions"
            [settings]="multiselectUsuariosDestinoSettings"
            [texts]="multiselectUsuariosDestinoTexts"
            [(ngModel)]="idsUsuariosDestino"
            (ngModelChange)="onChangeUsuariosDestino()">
        </ss-multiselect-dropdown>
    </div>
</div>